export default "__VITE_ASSET__9fd10268__"